import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

class Team {
  constructor() {
    this.setParallax()
  }

  setParallax() {
    this.images = document.querySelectorAll('.c-team-image')

    this.images.forEach((image) => {
      const wrapper = image.querySelector('.c-team-image__wrapper')
      const tl = gsap.timeline({}).from(
        wrapper,
        {
          y: 'random(150, 500)',
          duration: 0.2,
        },
        'start',
      )

      ScrollTrigger.create({
        trigger: image,
        start: 'top bottom+=20%',
        end: 'bottom bottom-=40%',
        animation: tl,
        scrub: 1,
      })
    })
  }
}

export default Team
